export const paths = Object.freeze({
  home: '/',
  contact: '/contactanos',
  consultar_medicamentos: '/consultar-de-medicamentos',
  agendar_cita: '/agendar-cita-medica',
  faq: '/preguntas-frecuentes',
  historial_citas: '/historial-citas',
  citas_medicas: '/citas-medicas',
  examenes_laboratorio: '/examenes-de-laboratorio',
  reporte_pdf: '/reporte-pdf/:id/:token',
  verificar_referencia: '/verificar-referencia/:token',
});

export const apiUrls = Object.freeze({
  contactForm: '/isbmController/contactForm',
  medicamentos: '/medicamentos/receta',
  botiquines: '/medicamentos/botiquin',
  consultaAfiliado: '/citas/consultaFiliado',
  agendarCita: '/citas/agendarCita',
  agendarCitaDoctor: '/citas/agendarCitaEspecialidad',
  recordatorio: '/citas/recordatorio',
  validateDate: '/citas/horasOcupadas',
  getFaqs: '/isbmController/faqs',
  reservaMedicamento: '/medicamentos/reservaMedicamento',
  consultaReserva: '/medicamentos/consultaReserva',
  listaCitas: '/citas/historicoCitas',
  cancelarCita: '/citas/anularCitas',
  consultaExamenes: '/laboratorio/consultaExamenes',
  resultadoExamenes: '/laboratorio/examenes',
  getEspecialistas: '/citas/especialistas',
  getEstablecimientos: '/citas/establecimientos',
  getMedicos: '/citas/medicos',
  getParametros: '/parametros/valorParametro',
  validateDoctorDate: '/citas/horasOcupadasEspecialistas',
  reportePdf: '/reportes/publico',
  reporteConfig: '/reportes/config',
  referenciaVerificacion: '/reportes/verificacion/referencia',
});

export const socialMedia: { [key: string]: string } = Object.freeze({
  youtube: 'https://youtube.com/c/IsbmGobSv',
  facebook: 'https://www.facebook.com/isbm.gob.sv',
  twitter: 'https://twitter.com/isbmsv?s=20&t=dpbOHooMVXJiYMIITrpPuA',
});
